import {Queries} from '../../api/queries';
import {Box, Checkbox} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {type SyntheticEvent, useCallback} from 'react';

interface ProjectPickerProps {
	/**
	 * Projects that should be checked, not indeterminate projects
	 */
	selectedProjectIds: Set<string>;
	/**
	 * Projects that are indeterminate, not checked projects
	 */
	indeterminateProjectIds?: Set<string>;
	onProjectDeselected: (projectId: string) => void;
	onProjectSelected: (projectId: string) => void;
}

const ProjectPicker = ({
	selectedProjectIds,
	indeterminateProjectIds,
	onProjectDeselected,
	onProjectSelected,
}: ProjectPickerProps) => {
	const {data: projects} = useQuery(Queries.projects());

	const onCheckboxChange = useCallback(
		(event: SyntheticEvent<HTMLInputElement>) => {
			const tagId = event.currentTarget.value;

			if (selectedProjectIds.has(tagId)) {
				onProjectDeselected(tagId);
			} else {
				onProjectSelected(tagId);
			}
		},
		[selectedProjectIds, onProjectSelected, onProjectDeselected],
	);

	return (
		<Box display='flex' flexDirection='column'>
			{projects?.map((project) => (
				<Box key={project.id} display='flex' alignItems='center' mb='space.200'>
					<Checkbox
						id={`checkbox-${project.id}`}
						checked={selectedProjectIds.has(project.id) || indeterminateProjectIds?.has(project.id)}
						indeterminate={indeterminateProjectIds?.has(project.id)}
						value={String(project.id)}
						onChange={onCheckboxChange}
						mr='space.300'
					/>

					{project.name}
				</Box>
			))}
		</Box>
	);
};

export default ProjectPicker;
